<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1" style="">
                <vs-table
                  @selected="handleSelected"
                  :max-items="paginationItems[1]"
                  pagination
                  :data="catalogeList"
                  :description="false"
                  search
                  :description-items="paginationItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div
                      style="
                        margin-right: auto;
                        font-size: 1.5rem;
                        font-weight: 550;
                      "
                    >
                      {{ $t("setup.label.SalseCatalogue") }}
                    </div>
                    <div class="mr-2 mb-1 order-1">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="$router.push({ name: 'Create Sales Cataloge' })"
                        size="small"
                        >{{ $t("setup.label.CreateSalesCatalogue") }}</vs-button
                      >
                    </div>
                  </template>

                  <template slot="thead">
                    <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                    <vs-th>{{ $t("setup.label.Name") }}</vs-th>
                    <vs-th class="tHeadCenter">
                      {{ $t("setup.label.Action") }}
                    </vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="catalogeList"
                      v-for="(catalogeList, index) in data"
                    >
                      <vs-td :data="catalogeList.id">{{
                        catalogeList.id
                      }}</vs-td>
                      <vs-td :data="catalogeList.name">{{
                        catalogeList.name
                      }}</vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EyeIcon"
                            :title="$t('setup.label.View')"
                            svgClasses="w-5 h-5 stroke-current cursor text-primary"
                            @click.stop="handleSelected(catalogeList)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            :title="$t('setup.label.Edit')"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editSalesCataloge(catalogeList.id)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('setup.label.Delete')"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="
                              deleteSalesCataloguePopup = true;
                              delId = catalogeList.id;
                            "
                            class="icon_row"
                          />
                          <feather-icon
                            icon="PlusIcon"
                            :title="$t('setup.label.AssignUsers')"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="assignUsersCatalogue(catalogeList.id, catalogeList.name)"
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteSalesCataloguePopup"
      :title="$t('setup.label.SalesCatalogue')"
      @deletePressed="deleteSalesCatalogue(delId)"
      @cancelPressed="deleteSalesCataloguePopup = false"
    ></delete-popup>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      deleteSalesCataloguePopup: false,
      paginationItems: [5, 10, 15],
      delId: 0,

      pages1: [
        { name: "SALES CATALOGE", active: "active" },
        { name: "USER CATALOGE", active: "inactive" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      catalogeList: "catalogueMapping/getCatalogeList",
      userCatalogeList: "catalogueMapping/getUserCatalogeList",
    }),
  },
  components: { AtomSpinner },
  methods: {
    handleSelected(catalogeList) {
      this.$router.push({
        name: "View Sales Cataloge",
        params: { id: catalogeList.id },
      });
    },
    async deleteSalesCatalogue(id) {
      try {
        this.deleteSalesCataloguePopup = false;
        await this.$store.dispatch(
          "catalogueMapping/deletesalescatalogeAction",
          id
        );
        await this.getCatalogeList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getCatalogeList() {
      this.loading = true;
      try {
        this.$store.dispatch("catalogueMapping/setsalescataloge");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editSalesCataloge(id) {
      this.$router.push({ name: "Edit Sales Cataloge", params: { id: id } });
    },
    assignUsersCatalogue(id, name) {
      this.$router.push({ name: "Assign Users Catalogue", params: { id: id, name: name } });
    },

    resetForm() {},
  },
  mounted() {
    this.getCatalogeList();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
